// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"336":"033b0f3c319a7721","533":"f5bd951895d502f4","818":"63bef79e79f5368d"}[chunkId] + ".js";
};